import { http } from "@/http/index.js"


// 维修模块-权限查看
// 维修完成信息查询-设备接收信息查询
const RepairComplateSearchByPermision = data => {
	data.SearchName = "报修"
	return http("api/SerApplyRepairCommit/RepairComplateSearch", { isFix: true, ...data }, "get")
}

// 权限删除
const RepairComplateDelete = data => {
	return http("api/SerApplyRepairCommit/RepairComplateDelete", data, "post")
}

const MessageReadLine = data => {
	return http("api/ApplyRepairCommit/MessageReadLine", data, "post")
}
// 发布消息
const MesageListAdd = data => {
	return http("api/ApplyRepairCommit/MesageListAdd", data, "post", null, null, true)
}
// websocket
const webConnect = () => {
	// http://192.168.1.242:8001/api/VisitRepairMainSearch/getmsg
	return http("api/VisitRepairMainSearch/getmsg", {}, "get")
}
// 备机列表删除 api/Standby/DelPreMachineListById
const DelPreMachineListById = data => {
	return http("api/Standby/DelPreMachineListById", data, "post")
}


// 备机列表保存添加界面保存按钮 api/Standby/PreMachineMangeFinishById
const PreMachineMangeFinishById = data => {
	return http("api/Standby/PreMachineAddCommit", data, "post")
}

// 保存 api/Standby/PreMachineEditeCommit
const PreMachineEditeCommit = data => {
	return http("api/Standby/PreMachineEditeCommit", data, "post")
}
// 备机详细信息 api/Standby/PreMachineListDetailSearch
const PreMachineListDetailSearch = data => {
	return http("api/Standby/PreMachineListDetailSearch", data, "get")
}
// 备机列表 api 
// api/Standby/PreMachineListSearch
const PreMachineListSearch = data => {
	return http("api/Standby/PreMachineListSearch", data, "get")
}
// 备机申请删除 api/Standby/DelPreMachineMangeById
const DelPreMachineMangeById = data => {
	return http("api/Standby/DelPreMachineMangeById", data, "post")
}
// 备机提交 api/Standby/PreMachineApplyCommit
const PreMachineApplyCommit = data => {
	return http("api/Standby/PreMachineApplyCommit", data, "post")
}
// 备机管理接口--备机借用详情 api/Standby/PreMachineMangeDetailSearch
const PreMachineMangeDetailSearch = data => {
	return http("api/Standby/PreMachineMangeDetailSearch", data, "get")
}
// 备机详情 api/Standby/PreMachineMangeSearch
const PreMachineMangeSearch = data => {
	return http("api/Standby/PreMachineMangeSearch", data, "get")
}
// 、备机借用详细信息归还(寄回)  api/Standby/PreMachineMangeDetailFinishById
const PreMachineMangeDetailFinishById = data => {
	return http("api/Standby/PreMachineMangeDetailFinishById", data, "post")
}
// 备机结单 
const PreMachineMangeFinishByIdNew = data => {
	return http("api/Standby/PreMachineMangeFinishById", data, "post")
}
// 验证sn api/Standby/SerialNoApplyCheck
const SerialNoApplyCheck = data => {
	return http("api/Standby/SerialNoApplyCheck", data, "post")
}


// 维修回访保存接口 api/VisitRepairMainSearch/VisitRepairAddSave
const VisitRepairAddSave = data => {
	return http("api/VisitRepairMainSearch/VisitRepairAddSave", data, "post")
}
// 维修回访结束
const VisitRepairAddComplete = data => {
	return http("api/VisitRepairMainSearch/VisitRepairComplete", data, "post")
}
// 维修回访 api/VisitRepairMainSearch/VisitRepairMain
const VisitRepairMain = data => {
	return http("api/VisitRepairMainSearch/VisitRepairMain", data, "get")
}
// 服务回访
const ServerRepairVisitSearch = data => {
	return http("api/VisitRepairMainSearch/ServerRepairVisitSearch", data, "get")
}
// 服务回访保存接口 api/VisitRepairMainSearch/ServerRepairVisitAdd
const ServerRepairVisitAdd = data => {
	return http("api/VisitRepairMainSearch/ServerRepairVisitAdd", data, "post")
}
// 服务回访完成
const ServerRepairVisitComplete = data => {
	return http("api/VisitRepairMainSearch/ServerComplete ", data, "post")
}
// 首页接口
// 获取每月报修量
const VisRepaiCount = data => {
	return http("api/ApplyRepairCommit/VisRepaiCount", data, "get")
}
// 首页header接口
const FirstPagePhoto = (data, url) => {
	return http(`api/ApplyRepairCommit/${url}`, data, "get")
}
// 首页底部表格接口

const VisRepairDesc = (data) => {
	return http("api/ApplyRepairCommit/VisRepairDesc", data, "get")
}
// 首页饼图接口
const VisSnZHanCount = (data) => {
	return http("api/ApplyRepairCommit/VisSnZHanCount", data, "get")
}
// 领取任务
const ReceivingOrders = data => {
	return http("api/ServerPlantTask/ReceivingOrders", data, "post")
}
const DelUserInfoById = data => {
	return http("api/MyUserInfoes/DelUserInfoById", data, "post")
}
// sn管理 添加sn
const addSN = data => {
	return http("api/ServerPlantTask/SNEdit", data, "post")
}
//获取公司信息列表
const infoCompany = data => {
	return http("api/CompanyPageSearch/GetData", data, "get")
}
//导出公司信息
const exportCompany = data => {
	debugger
	return http("api/CompanyPageSearch/GetDataCompanyList", data, "get", true)
}
//获取上级公司信息
const ParentCompName = data => {
	return http("api/SearchCompany/GetData", data, "get")
}
//获取上级公司信息
const ParentCompNameZone = data => {
	return http("api/CompanyPageSearch/CompSubarea", data, "get")
}

//获取角色权限管理列表
const menuPower = data => {
	return http("api/PermissionObject/GetData", data, "get")
}

//获取用户角色权限管理列表
const userRole = data => {
	return http("api/MyUserInfoes/GetData", data, "get")
}

//获取用户管理列表
const userInfo = data => {
	return http("api/UserInfoSearch/UserInfoSearch", data, "get")
}
// 根据用户输入远程搜索   /api/ProductCategory/ModelLike
const CompanyInfoTypeRemote = data => {
	return http("api/ProductCategory/ModelLike", data, "get")
}
// 根据用户输入型号获取品牌和名称
const CompanyInfoType = data => {

	return http("api/ProductCategory/ModelProBrand", data, "get")
}
//获取公司id列表
const CompanyInfoId = data => {

	return http("api/MyUserInfoes/CompanyInfoesData", data, "get")
}
//新增用户获取公司id列表
const CompanyInfoesDatas = data => {
	return http("api/MyUserInfoes/CompanyInfoesDatas", data, "get")
}
//获取角色id列表
const roleInfoId = data => {
	return http("api/MyUserInfoes/userRigntsData", data, "get")
}

// 角色下拉框
const RoleData = data => {
	return http("api/MyUserInfoes/RoleData", data, "get")
}

//获取字典信息列表
const dictionaryList = data => {
	return http("api/DaDicInfoAll/ProcessRequest", data, "get")
}
//获取字典类别下拉列表
const dictionarySelectList = data => {
	return http("api/DaDicInfoAll/DadicInfoSearchs", data, "get")
}
//获取字典上级类别下拉列表
const ProcessRequestSelect = data => {
	return http("api/DaDicInfoAll/ProcessRequestSelect", data, "get")
}

//字典类别信息显示
const DadicInfoSearchsType = data => {
	return http("api/DaDicInfoAll/DadicInfoSearchsType", data, "get")
}

// 增加知识库
//知识库列表
const WechatRobotReplySelect = data => {
	return http("api/ModelNoSearch/WechatRobotReplySelect", data, "get")
}
// //获取字典类别下拉列表
// const dictionarySelectList = data => {
// 	return http("api/DaDicInfoAll/DadicInfoSearchs", data, "get")
// }
// //获取字典上级类别下拉列表
// const ProcessRequestSelect = data => {
// 	return http("api/DaDicInfoAll/ProcessRequestSelect", data, "get")
// }

// //字典类别信息显示
// const DadicInfoSearchsType = data => {
// 	return http("api/DaDicInfoAll/DadicInfoSearchsType", data, "get")
// }


//获取品牌信息列表
const BrandSearch = data => {
	return http("api/Brand/BrandSearch", data, "get")
}

//获取产品类别信息
const BrandType = data => {
	return http("api/ProductCategory/ProductCategorySearch", data, "get")
}



//品牌下拉框 
const BrandSelect = name => {
	name = name || ''
	return http("api/Brand/BrandSearchs", { name }, "get")
}
//产品类别下拉框
const ProductSelect = Bid => {

	return http("api/ProductCategory/ProductCategorySearchs", Bid, "get")
}
//型号下拉框
const modelSelect = ProductCategoryId => {
	if (typeof ProductCategoryId != 'object') {
		ProductCategoryId = {
			ProductCategoryId
		}
	}
	return http("api/ModelNoSearch/ModelNosSelect", ProductCategoryId, "get")
}




//附件下拉框
const AttachSelect = ProductCategoryId => {
	// ProductCategoryId = ProductCategoryId || 0
	if (typeof ProductCategoryId != 'object') {
		ProductCategoryId = {
			ProductCategoryId
		}
	}
	return http("api/AttachInfo/AttachInfoSelects", ProductCategoryId, "get")
}
//症状下拉框
const ModelIllSelect = ProductCategoryId => {
	if (typeof ProductCategoryId != 'object') {
		ProductCategoryId = {
			ProductCategoryId
		}
	}
	return http("api/ModelIll/ModelIllSearchs", ProductCategoryId, "get")
}
//报修申请列表
const getRepairList = data => {
	return http("api/ApplyRepairCommit/ApplySelect", data, "get")
}


//型号信息
const ModelNoSelect = data => {
	data.BrandId = data.BrandId || null
	data.ProductId = data.ProductId || null
	return http("api/ModelNoSearch/ModelNoSelect", data, "get")
}

// 配件信息 
const partsInfo = data => {
	return http("api/Fitting/FittingSearch", data, "get")
}

// 维修级别 
const repairLevel = data => {
	return http("api/LevelSearch/LevelSearchIndex", data, "get")
}

// 维修级别 下拉
const LevelSearchs = data => {
	return http("api/LevelSearch/LevelSearchs", data, "get")
}

// 附件信息  
const attachList = data => {
	return http("api/AttachInfo/AttachInfoSelect", data, "get")
}

// 症状信息  
const symptomList = data => {
	return http("api/ModelIll/ModelIllSearch", data, "get")
}

// 公司联系人
const contactsList = data => {
	data.companyId = data.companyId || 0
	return http("api/CompanyContract/CompanyContractSearch", data, "get")
}

//
// 公司联系人
const CompanyInfoesData = () => {
	return http("api/MyUserInfoes/CompanyInfoesData", null, "get")
}

// 客户下拉列表全量数据
const CompanyInfo = (data) => {
	// return http("api/MyUserInfoes/CompanyInfoesData", null, "get")

	return http("api/MyUserInfoes/CompanyInfoesDatas", data, "get")
}
// 只显示属于维修中心的公司数据
const CompanyInfoService = () => {
	// return http("api/MyUserInfoes/CompanyInfoService", null, "get")
	return http("api/MyUserInfoes/CompanyInfoService", null, "get")
}
// 只显示属于维修中心的公司数据
const CompanyInfoShooin = () => {
	return http("api/MyUserInfoes/CompanyInfoShooin", null, "get")
}


// shooin下拉列表数据
const MyUserInfoeShooin = () => {
	// return http("api/MyUserInfoes/CompanyInfoesData", null, "get")

	return http("api/MyUserInfoes/CompanyInfoShooin", null, "get")
}
// 公司联系人模块
const CompanyInfoesDatasGSLXR = () => {
	// return http("api/MyUserInfoes/CompanyInfoesData", null, "get")

	return http("api/MyUserInfoes/CompanyInfoesDatas ", null, "get")
}
// 客户下拉列表 权限数据
const CompanyInfoRole = () => {
	return http("api/MyUserInfoes/CompanyInfoesData", null, "get")
}
// 报修申请列表
const CusRepairListData = data => {
	return http("api/CusRepairTransfer/CusRepairListSearch", data, "get")
}
// 运送到维修中心
const CusRepairTransfer = () => {
	return http("api/CusRepairTransfer/CusRepairSelect", null, "get")
}
//维修维修中心
const CompanyInfoes = () => {
	return http("api/MyUserInfoes/CompanyInfoesData", null, "get")
}
const linkMan = (Company_Id) => {
	Company_Id = Company_Id || null
	return http("api/Guarantee/CompanyContracts", Company_Id, "get")
}

// 维修设备信息临时列表
const RepairSelect = data => {
	return http("api/ApplyRepairCommit/RepairSelect", data, "get")
}

// 维修检测信息查询
const RepairDetectSearch = data => {
	return http("api/SerApplyRepairCommit/RepairDetectSearch", data, "get")
}
// 设备维修信息查询
const RepairProductSearch = data => {
	return http("api/SerApplyRepairCommit/RepairProductSearch", data, "get")
}
// 设备返回信息查询
const RepairTransferReturn = data => {
	return http("api/SerApplyRepairCommit/RepairTransferReturn", data, "get")
}
// 维修完成确认
const ConfirmCompletion = data => {
	data.SearchName = "报修"
	return http("api/SerApplyRepairCommit/ConfirmCompletion", data, "get")
}
// 维修完成信息查询-设备接收信息查询
const RepairComplateSearch = data => {
	return http("api/SerApplyRepairCommit/RepairComplateSearch", data, "get")
}
// 返厂名称信息查询
const BackFactory = data => {
	return http("api/SerApplyRepairCommit/BackFactory", data, "get")
}
// 合同信息查询
const ContractSearch = data => {
	return http("api/Contract/ContractSearch", data, "get")
}

// 过期合同信息查询
const ContractOldSearch = data => {
	return http("api/Contract/ContractOldSearch", data, "get")
}

// sn信息查询
const SNSearch = data => {
	return http("api/Contract/SNSearch", data, "get")
}

// 一、巡检要求
const RequireSelect = data => {
	return http("api/Require/RequireSelect", data, "get")
}

// 巡检任务信息查询
const ServerPlantTasksSearch = data => {
	return http("api/ServerPlantTask/ServerPlantTasksSearch", data, "get")
}
// 客户列表信息查询
const RepairPlantSNSearchs = data => {
	return http("api/ServerPlantTask/RepairPlantSNSearchs", data, "get")
}
// SN信息查询
const RepairSNSearch = data => {
	return http("api/ServerPlantTask/RepairSNSearch", data, "get")
}
// 巡检记录查询
const ServerPlantTaskSearchForComplateData = data => {
	return http("api/ServerPlantTask/ServerPlantTaskSearchForComplateData", data, "get")
}
// SN管理查询
const NoContractSnsSearch = data => {
	return http("api/ServerPlantTask/NoContractSnsSearch", data, "get")
}
// 服务申请信息查询
const ServerRepairDetailSearch = data => {
	return http("api/ServerPlantTask/ServerRepairDetailSearch", data, "get")
}
// 服务进度信息查询
const ServerRepairDetailsStepSearch = data => {
	return http("api/ServerPlantTask/ServerRepairDetailsStepSearch", data, "get")
}
//服务记录信息查询
const ServerRepairDetailSearchForComplate = data => {
	return http("api/ServerPlantTask/ServerRepairDetailSearchForComplate", data, "get")
}
//设备接收信息查询
const RepairReciveSearch = data => {
	return http("api/SerApplyRepairCommit/RepairReciveSearch", data, "get")
}
//客户付款方式
const CusPayType = data => {
	return http("api/SerApplyRepairCommit/CusPayType", data, "get")
}

//客户报价方式
const CusPriceType = data => {
	return http("api/SerApplyRepairCommit/CusPriceType", data, "get")
}
//SN号详细信息查询
const SearchCusApplyRepairBySN = data => {
	return http("api/ApplyRepairCommit/SearchCusApplyRepairBySN", data, "get")
}
//SN号详细信息查询
const SearchCusApplyRepairBySNS = data => {
	return http("api/ApplyRepairCommit/SearchCusApplyRepairBySNS", data, "get")
}
//服务记录导出
const FuDaoContractList = data => {
	return http("api/ServerPlantTask/FuDaoContractList", data, "get", true)
}
//设备维护导出
const EquipmentsindexList = data => {
	return http("api/SerApplyRepairCommit/EquipmentsindexList", data, "get", true)
}
//巡检记录导出
const XuanJianDaoChu = data => {
	return http("api/ServerPlantTask/XuanJianDaoChu", data, "get", true)
}
//维修完成导出
const RepairComplateDaoChu = data => {
	return http("api/ServerPlantTask/RepairComplateDaoChu", data, "get", true)
}
//维修状态导出
const RepairComplateDaoChuState = data => {
	return http("api/SerApplyRepairCommit/RepairProductSearchAllExport", data, "get", true)
}
//SN号导出 (合同里的)导出
const SNSearchDao = data => {
	return http("api/Contract/SNSearchDao", data, "get", true)
}
//货运公司
const SearchCompany = data => {
	return http("api/SerApplyRepairCommit/SearchCompany", data, "get")
}
// 货运公司
const TransComp = data => {
	return http("api/SerApplyRepairCommit/TransComp", data, "get")
}
// 运输方法
const TransMethod = data => {
	return http("api/SerApplyRepairCommit/TransMethod", data, "get")
}
// 寄送方法
const TransFangshi = data => {
	return http("api/SerApplyRepairCommit/TransFangshi", data, "get")
}
// 维保服务类型
const WeiBaoFangshi = data => {
	return http("api/SerApplyRepairCommit/WeiBaoFangshi", data, "get")
}

// 维保服务类型----type
const WeiBaoFangshiType = data => {
	return http("api/Contract/WeiBaoType", data, "get")
}

// 设备清单信息查询
const Equipmentsindex = data => {
	return http("api/SerApplyRepairCommit/Equipmentsindex", data, "get")
}
// 巡检数量查找

// 公告信息查询
const MesageNewShowSearch = data => {
	return http("api/ApplyRepairCommit/MesageNewShow", data, "get")
}
// 维修状态查询
const ChangeRepairDetailState = data => {
	return http("api/SerApplyRepairCommit/RepairProductSearchAll", data, "get")
}


export default {
	EquipmentsindexList,
	RepairComplateDelete,
	MessageReadLine,
	MesageListAdd,
	webConnect,
	DelPreMachineListById,
	PreMachineMangeFinishById,
	PreMachineEditeCommit,
	PreMachineListDetailSearch,
	PreMachineListSearch,
	DelPreMachineMangeById,
	PreMachineApplyCommit,
	SerialNoApplyCheck,
	PreMachineMangeDetailFinishById,
	PreMachineMangeFinishByIdNew,
	PreMachineMangeSearch,
	PreMachineMangeDetailSearch,
	VisitRepairAddSave,
	VisitRepairAddComplete,
	VisitRepairMain,
	ServerRepairVisitAdd,
	ServerRepairVisitComplete,
	ServerRepairVisitSearch,
	VisSnZHanCount,
	VisRepairDesc,
	FirstPagePhoto,
	VisRepaiCount,
	ReceivingOrders,
	addSN,
	CompanyInfoType,
	CompanyInfoTypeRemote,
	DelUserInfoById,//用户信息删除
	CompanyInfoesDatasGSLXR,
	CompanyInfoShooin,//shooin下拉列表
	menuPower,
	infoCompany,
	exportCompany,
	ParentCompName,
	ParentCompNameZone,
	userRole,
	userInfo,
	RoleData,
	CompanyInfoId,
	roleInfoId,
	WechatRobotReplySelect,
	dictionaryList,
	dictionarySelectList,
	BrandSearch,
	BrandType,
	BrandSelect,
	ProductSelect,
	modelSelect,
	ModelNoSelect,
	AttachSelect,
	ModelIllSelect,
	partsInfo,
	repairLevel,
	attachList,
	symptomList,
	contactsList,
	CompanyInfo,
	CompanyInfoService,
	MyUserInfoeShooin,
	CompanyInfoesData,
	CusRepairListData,
	CusRepairTransfer,
	CompanyInfoes, //维修中心查询
	linkMan,
	getRepairList,
	RepairSelect,
	RepairDetectSearch,
	RepairProductSearch,
	RepairTransferReturn,
	ConfirmCompletion,
	RepairComplateSearch,
	ContractSearch,
	ContractOldSearch,
	SNSearch,
	ServerPlantTasksSearch,
	RepairPlantSNSearchs,
	RepairSNSearch,
	ServerPlantTaskSearchForComplateData,
	NoContractSnsSearch,
	ServerRepairDetailSearch,
	ServerRepairDetailsStepSearch,
	ServerRepairDetailSearchForComplate,
	BackFactory,
	RepairReciveSearch,
	ProcessRequestSelect,
	CusPayType,
	CusPriceType,
	LevelSearchs,
	SearchCusApplyRepairBySN,
	SearchCusApplyRepairBySNS,
	FuDaoContractList,
	XuanJianDaoChu,
	SNSearchDao,
	RepairComplateDaoChu,
	RepairComplateDaoChuState,
	TransComp,
	TransFangshi,
	TransMethod,
	WeiBaoFangshi,
	WeiBaoFangshiType,
	DadicInfoSearchsType,
	RequireSelect,
	Equipmentsindex,
	CompanyInfoesDatas,
	SearchCompany,
	CompanyInfoRole,
	RepairComplateSearchByPermision,
	ChangeRepairDetailState,
	MesageNewShowSearch

}